webpackJsonp([263791100135453],{

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(46);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'About me'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'My name is Stevica Knezevic and I am a web developer who lives and breathes the code.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'As a true technology buff, I am always looking for new ways to improve my skills. But this is not an easy task since everything is moving at a fast pace. This is where love comes into play. Nothing makes me happier than building apps using JavaScript and other web-related technologies! I know it sounds like I\u2019m exaggerating, but it\u2019s true. Even reading about the latest technology developments can motivate me to create something I have never created before.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Because of my desire to learn new things, I became interested in exploring technologies that are not strictly front-end related, such as Node frameworks (Hapi.js, Express.js), Socket.io, Docker and various services like AWS. This is just a small part of what I do, so if you want to find out more about this, you should check out my Portfolio page.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Work Experience:'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://www.lambdaworks.io' },
	        'Lambdaworks'
	      ),
	      ' ',
	      '- Full-Stack JavaScript Developer'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Developing the PRM app using React, Redux, GraphQL, WebSocket, Express.js and Webpack consuming API service built in Scala.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://brisqq.com/' },
	        'Brisqq'
	      ),
	      ' ',
	      '- Full-Stack JavaScript Developer'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Developing the app using React, Redux, Socket.io, Lodash, Semantic UI (consuming API service built in Hapi framework). Also I participate in discovery phase in order to apply serverless approach to our platform, using AWS services like Kinesis, Lambda, Elasticsearch.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://www.etondigital.com/' },
	        'EtonDigital'
	      ),
	      ' ',
	      '- JavaScript Developer'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Developing the applications and social networks using Angular framework consuming API service built in Symfony as well as front-end implementation using Drupal CMS.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'As a Front-End developer I had the chance to work on challenging projects for brands such as Hyundai, Nissan, Savvy-Investor, Cytoo, TallyFox. My main responsibilities besides writing code were the selection of technologies for the given project and planning the application structure. I used modern frameworks and libraries like AngularJS, Angular 2, TypeScript, RxJS, jQuery, Underscore, Node.js, SASS/Compass, Twig, Drupal.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://www.serviceplus-it.com/' },
	        'Service Plus Group'
	      ),
	      ' ',
	      '- Application support'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Working as application support using software for managing all activities on petrol stations, providing following activities: Software integration and data migration projects, pilot and field installations, transations troubleshooting, network monitoring, configuration of the forecourt controllers payment terminals (IPT, OPT), generating, export/import PK (private keys) on the HSM, for FST\u2019s.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Social:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you want to learn more about me, you can find me on:',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://twitter.com/knezevic84' },
	        'Twitter'
	      ),
	      ',',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://www.linkedin.com/in/stevicaknezevic/' },
	        'Linkedin'
	      ),
	      ',',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://github.com/stevica' },
	        'GitHub'
	      ),
	      ' ',
	      'and',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://www.instagram.com/knezevicsteva/' },
	        'Instagram'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'My spare time:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When I am not working or learning, I enjoy working out, having fun with my friends and traveling. I especially love to cook, because it relaxes me and keeps my mind off things. One day, I hope to fulfill one of my wishes to try Wingsuit flying.'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      'Go back to the homepage'
	    )
	  );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-d503cfd0a09a4fd5108e.js